module.exports = __webpack_public_path__ + "img/和泉玲央.9a164553.jpg";